import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class ApiService {
    static async uploadClientsFile (importFile) {
        try {
            let formData = new FormData()
            formData.append('importFile', importFile)

            let { data } = await axios.post(`${url}/uploadFile`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getImportData (fileName) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/getImportData/${fileName}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async confirmImport (fileName) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/confirmImport/${fileName}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getScianCatalog (scianCode) {
        try {
            let { data } = await axios.get(`${process.env.VUE_APP_UTILS_API}/api/scianCatalog/${scianCode || ''}`, { withCredentials: false })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getCountries (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`/api/countries`, { headers, params })
            Promise.resolve(data)
        } catch (error) {
            Promise.reject(error)
        }
    }

    static async getStates (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`/api/states`, { headers, params })
            Promise.resolve(data)
        } catch (error) {
            Promise.reject(error)
        }
    }

    static async validateIndicators () {
        headers['Authorization'] = await Utils.setLocalToken()
        const { data } = await axios.get(`/api/validate-indicators`, { headers })
        return data.data
    }
}
